import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { View, ScrollView } from 'react-native';
import { component } from '../../Decorators/Component';
import { CoreConfig } from './../../../CoreConfig';
export const NiceScrollView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    style: {
        container: {
            flex: 1,
            flexDirection: 'row'
        },
        scrollContainer: {
            paddingEnd: 10
        },
        scrollTrack: {
            width: 6,
            overflow: 'hidden',
            backgroundColor: '#dbe2eb',
            borderRadius: 8,
        },
        scrollThumb: {
            width: 6,
            borderRadius: 8,
            backgroundColor: '#1155CC',
        }
    }
})(({ children, style }) => {
    const [contentSize, setContentSize] = useState(0);
    const [scrollViewHeight, setScrollViewHeight] = useState(0);
    const [scrollPercent, setScrollPercent] = useState(0);
    const scrollThumbPercent = 40;
    const scrollTrack = contentSize > scrollViewHeight ? 100 : 0;
    return (_jsxs(View, { style: style === null || style === void 0 ? void 0 : style.container, children: [_jsx(ScrollView, { contentContainerStyle: style === null || style === void 0 ? void 0 : style.scrollContainer, showsVerticalScrollIndicator: false, nestedScrollEnabled: true, onContentSizeChange: (_, height) => setContentSize(height), onLayout: e => setScrollViewHeight(e.nativeEvent.layout.height), onScroll: e => {
                    const contentOffset = e.nativeEvent.contentOffset;
                    const calcThumbLocation = (contentOffset.y / (contentSize - scrollViewHeight)) * (100 - scrollThumbPercent);
                    setScrollPercent(calcThumbLocation);
                }, scrollEventThrottle: 16, children: children }), _jsx(View, { style: [style === null || style === void 0 ? void 0 : style.scrollTrack, { height: `${scrollTrack}%` }], children: _jsx(View, { style: [
                        style === null || style === void 0 ? void 0 : style.scrollThumb,
                        {
                            position: "absolute",
                            top: `${Number(scrollPercent || 0).toFixed(0)}%`,
                            height: `${scrollThumbPercent}%`
                        }
                    ] }) })] }));
});
